import { initializeModal, openModal } from "./gallery-modal"
import { initializeSwiper, jumpToSlide } from "./gallery-slider"
import { initializeSharedModal, openSharedModal } from "./shared-gallery-modal"

const galleryThumbnails = (): Array<HTMLElement> => [
    ...(document.querySelectorAll(
        ".auftrag-title .auftrag-main-thumb, .girl-galerie .gallery_item, .club-gallery-container .gallery_item, .telefonsex-thumbnail .gallery_item, .telefonsex-thumbnail.gallery_item",
    ) as NodeListOf<HTMLElement>),
]

const sharedGalleryThumbnails = (): Array<HTMLElement> => [
    ...(document.querySelectorAll(".fkk-specials a.events-gallery-item") as NodeListOf<HTMLElement>),
]

export function initGallery(): void {
    for (const thumbnail of galleryThumbnails()) {
        thumbnail.addEventListener("click", (event: Event): void => {
            event.preventDefault()

            jumpToSlide(Number.parseInt(thumbnail.dataset.index as string, 10))
            openModal()
        })
    }

    initializeSwiper()
    initializeModal()
}

export function initSharedGallery(): void {
    for (const thumbnail of sharedGalleryThumbnails()) {
        thumbnail.addEventListener("click", (event: Event): void => {
            event.preventDefault()

            openSharedModal(thumbnail)
        })
    }

    initializeSharedModal()
}
